
function setPurchases(data) {
	return {
		type: "SET_PURCHASES",
		payload: data,
	};
}

export { setPurchases };
